<div class="form-group">
  @if (showLabel && (labelText || question?.email_version)) {
    <label [for]="uniqueControlId" class="form-group__label">
      {{question?.email_version ? question?.email_version : labelText}}
    </label>
  }
  @if (readOnly) {
    <input type="text" disabled="" [value]="question?.answer" placeholder="Placeholder" class="form-control">
  }
  @if (!readOnly) {
    <select [name]="uniqueControlName" [id]="uniqueControlId" class="ui-selectmenu">
      <option value="">{{(showOptionLabel && labelText) ? (labelText | titlecase) : 'Select Option'}}</option>
      @for (option of options; track option) {
        <option [value]="getValue(option)" [selected]="getSelectedOption(option)">{{formatOptionText(option)}}</option>
      }
    </select>
  }
</div>
